import { Tab, Tabs, Box, Modal } from "@mui/material"
import { ModalCatalogsStyles } from "./ModalCatalogsStyles";
import TabPanel from "./TabPanel";
import AddOrEditProductForm from "../AddOrEditProductForm/AddOrEditProductForm";
import { useEffect, useState } from "react";
import AddOrEditProvidenceForm from "../AddOrEditProvidenceForm/AddOrEditProvidenceForm";
import FileUploadForm from "../FileUploadForm/FileUploadForm";


const ModalCatalogs = ({openModal,handleCloseModal, tabValue, handleChangeTap, pathname}) => {
    const [showProductForm, setShowProductForm] = useState(false)
    const [showProvidcenForm, setShowProvidenceForm] = useState(false)
    const [titleTab1, setTitleTab1] = useState("")

    useEffect(() => {        
        if (pathname.includes("/dashboard/products")) {
            setShowProductForm(true)
            setShowProvidenceForm(false)
            setTitleTab1("Add product")            
        } else if (pathname === "/dashboard/provinces"){
            setShowProductForm(false)
            setShowProvidenceForm(true)
            setTitleTab1("Add providence")
        }
    },[pathname])


    return (
        <>
            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={ModalCatalogsStyles.boxModal}>
                    <Tabs value={tabValue} onChange={handleChangeTap} aria-label="tabs">
                        <Tab label={titleTab1}/>
                        {(pathname === "/dashboard/products" || pathname === "/dashboard/products/CatGeneric" || pathname === "/dashboard/provinces" ? <Tab label="Upload CSV" /> : "")}
                    </Tabs>
                    <TabPanel value={tabValue} index={0}>
                        {showProductForm && <AddOrEditProductForm handleCloseModal={handleCloseModal} action="ADD" productOject={null}/>}
                        {showProvidcenForm && <AddOrEditProvidenceForm handleCloseModal={handleCloseModal} action="ADD" productOject={null}/>}
                    </TabPanel>
                    <TabPanel value={tabValue} index={1}>
                        <FileUploadForm handleCloseModal={handleCloseModal}/>
                    </TabPanel>
                </Box>
            </Modal>
        </>   
    )
}
export default ModalCatalogs